import React, { useEffect } from 'react';
import { Confirm, ConfirmModalType } from '../components/Modal/ConfirmModal';
import { envVar } from '../util/Util/EnvVar';
import { useTranslation } from 'react-i18next';
import { createError } from 'util/FormatError';
import { logger } from 'util/Logger';

export default function useDetectVersionUpdate(): void {
  const { t } = useTranslation();

  /**
   * Check if the user is using an old version --> commit-hash.json
   * If so, show a modal with a message to refresh the page
   */
  useEffect(() => {
    if (envVar('NODE_ENV') !== 'development') {
      const abortController = new AbortController();
      let modalIsVisible = false;
      const interval = setInterval(() => {
        fetch(`/commit-hash.json?nocache=${Date.now()}`, { signal: abortController.signal })
          .then(res => res.text())
          .then(res => {
            // eslint-disable-next-line
            // @ts-ignore
            const currentGitCommitHash = `${GIT_COMMIT_HASH}`;
            const newGitCommitHash = JSON.parse(res).commitHash;

            if (newGitCommitHash && newGitCommitHash !== currentGitCommitHash && !modalIsVisible) {
              modalIsVisible = true;
              Confirm({
                showSideIcon: true,
                type: ConfirmModalType.Warning,
                title: t('outdated-version', 'Outdated Version'),
                text: (
                  <div className='flex items-center gap-x-2'>
                    <p>
                      {t(
                        'you-are-using-an-outdated-version-of-the-app-refresh-to-load-new-version',
                        'You are using an outdated version of the App. Please refresh the page to load the new version of the App.',
                      )}
                    </p>
                  </div>
                ),
                showCancelButton: false,
                confirmText: t('refresh-now', 'Refresh now'),
                onConfirm: () => document.location.reload(),
              });
            }
          })
          .catch(error => logger.error(createError('Cannot detect current commit-hash', error)));
      }, 1000 * 60);

      return () => {
        clearInterval(interval);
        abortController.abort();
      };
    }
  }, [t]);
}
